import _classCallCheck from "/Users/yawjosephetse/Developer/repetere/periodicjs.ext.reactapp/adminclient/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/yawjosephetse/Developer/repetere/periodicjs.ext.reactapp/adminclient/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/Users/yawjosephetse/Developer/repetere/periodicjs.ext.reactapp/adminclient/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/yawjosephetse/Developer/repetere/periodicjs.ext.reactapp/adminclient/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/Users/yawjosephetse/Developer/repetere/periodicjs.ext.reactapp/adminclient/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

import React, { Component, PropTypes } from 'react';
import styles from '../../build/styles';

var Subtitle =
/*#__PURE__*/
function (_Component) {
  _inherits(Subtitle, _Component);

  function Subtitle() {
    _classCallCheck(this, Subtitle);

    return _possibleConstructorReturn(this, _getPrototypeOf(Subtitle).apply(this, arguments));
  }

  _createClass(Subtitle, [{
    key: "createClassName",
    value: function createClassName() {
      return [styles.subtitle, styles[this.props.size], this.props.className].join(' ').trim();
    }
  }, {
    key: "render",
    value: function render() {
      return React.createElement('p', _extends({}, this.props, {
        className: this.createClassName()
      }), this.props.children);
    }
  }]);

  return Subtitle;
}(Component);

export { Subtitle as default };
Subtitle.propTypes = {
  children: PropTypes.any,
  className: PropTypes.string,
  size: PropTypes.oneOf(['is1', 'is2', 'is3', 'is4', 'is5', 'is6'])
};
Subtitle.defaultProps = {
  className: ''
};